import axios from "axios";
import { url, invitationKey, user_id, auth_key } from "../../constants";

const stoqqyLang = window.localStorage.getItem("stoqqyLang");

export const getGeneralInfo = async (ISIN) => {
  try {
    const response = await axios.post(
      `${url}description/${ISIN}?language=${stoqqyLang}`,

      {},
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getETFGeneralInfo = async (ISIN) => {
  try {
    const response = await axios.get(
      `${url}/etfgeneral/${ISIN}?language=${stoqqyLang}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getHoldings = async (ISIN) => {
  try {
    const response = await axios.get(
      `${url}etfholdings/${ISIN}?language=${stoqqyLang}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCompetators = async (ISIN, filters) => {
  try {
    const stoqqyLang = window.localStorage.getItem("stoqqyLang");
    const response = await axios.post(
      `${url}/competitors/${ISIN}?Invitation=${invitationKey}&&language=${stoqqyLang}`,

      filters,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBrands = async (ISIN) => {
  try {
    const response = await axios.get(`${url}company/4/${ISIN}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getNews = async (ISIN) => {
  try {
    const response = await axios.get(
      `${url}news/${ISIN}?language=${stoqqyLang}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBonds = async (ISIN) => {
  try {
    const stoqqyLang = window.localStorage.getItem("stoqqyLang");
    const response = await axios.post(
      `${url}bonds/${ISIN}`,
      {},
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const translateNews = async (text) => {
  try {
    const stoqqyLang = window.localStorage.getItem("stoqqyLang");
    const response = await axios.post(
      `${url}/translator`,

      {
        text: text,
        language: stoqqyLang,
      },
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSource = async (ISIN) => {
  try {
    const response = await axios.get(`${url}source_link/${ISIN}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
